module.exports = __webpack_public_path__ + "img/PcTitle.b3af2eb9.png";